import { computed } from "mobx";
import { inject, observer } from "mobx-react";

import Real from "./Real";
import Ghost from "./Ghost";

const CompaniesEdit = inject("mainStore")(
    observer(({ mainStore }) => {
        const detailData = computed(() => mainStore.getMainStore("detailData")).get();

        const Specified = detailData?.ghostOffer ? Ghost : Real;

        return <Specified />;
    }),
);

export default CompaniesEdit;
